<!-- <div class="input-group" [formGroup]="imageForm" enctype="multipart/form-data" contentType="false">
  <div class="custom-file">
    <input [attr.disabled]="disabled ? '' : null" (change)="handleFileInput($event)" [accept]="fileAccessType[data.fileType].accessType" type="file"
      formControlName="pimage" class="custom-file-input"/>
      <label for="redirect_link" class="custom-file-label">{{data?.label | titlecase}}</label>
      @if (!fileInfos.progress && fileStatusMessage) {
        <span class="error">{{fileStatusMessage}}</span>
      }
    </div>
  </div>
  <div class="pt-2">
    @if (!fileInfos.progress) {
      <img imageLoad [src]="fileInfos.filePath" class="img-thumbnail w100 h100">
    }
  </div>
  @if (fileInfos.progress) {
    <div class="progress">
      <div class="progress-bar" [style.width.%]="fileInfos.progress">
      {{fileInfos.progress}}%</div>
    </div>
  } -->

<p-fileUpload (onSelect)="handleFileInput($event)" [disabled]="disabled ? true : false" [auto]="true" [multiple]="false"
  [maxFileSize]="1000000" [invalidFileSizeMessageSummary]="fileStatusMessage"
  [accept]="fileAccessType[data.fileType].accessType">
  <ng-template let-file pTemplate="file">
    <div></div>
  </ng-template>
  <ng-template pTemplate="content">
    @if (!fileInfos.progress) {
    @if (fileInfos.filePath) {
    @if (fileInfos.filePath.split('.').pop() === 'xlsx') {
    <div class="d-flex gap-2 ">
      <img src="../../../../assets/images/xlsx.png" height="20px" width="20px" alt="Excel file icon">
      <p class="file-name">
        {{ fileName}}
      </p>
    </div>

    } @else {
    <img [src]="fileInfos.filePath" class="img-fluid h-100 rounded mt-2" style="max-height: 200px;" alt="File preview">
    }

    }@else {
    <span>
      Drag and drop or choose files</span>
    }
    }@else {
    <div class="progress">
      <div class="progress-bar" [style.width.%]="fileInfos.progress">
        {{fileInfos.progress}}%</div>
    </div>
    }
  </ng-template>
</p-fileUpload>
@if (!fileInfos.progress && fileStatusMessage) {
<span class="error">{{fileStatusMessage}}</span>
}